<div class="container d-flex flex-column align-items-start p-3">
  <div mat-dialog-title class="title-container d-flex align-items-center mb-4">
    <div class="icon-container mr-3" *ngIf="icon !== 0">
      <mat-icon
        *ngIf="icon === 1"
        svgIcon="confirmation"
        class="title-icon confirmation"
      ></mat-icon>
      <mat-icon
        *ngIf="icon === 2"
        svgIcon="information"
        class="title-icon information"
      ></mat-icon>
      <mat-icon
        *ngIf="icon === 3"
        svgIcon="warning"
        class="title-icon warning"
      ></mat-icon>
      <mat-icon
        *ngIf="icon === 4"
        svgIcon="warning-triangle"
        class="title-icon primary"
      ></mat-icon>
    </div>
    <h4 *ngIf="title" class="title mb-0">{{ title }}</h4>
  </div>
  <div mat-dialog-content class="d-flex flex-grow-1">
    <div class="title-icon invisible mr-3"></div>
    <div class="content-container">
      <p *ngIf="information">{{ information }}</p>
      <p *ngIf="!!informationLine2">{{ informationLine2 }}</p>
      <p *ngIf="message">{{ message }}</p>
    </div>
  </div>
  <div mat-dialog-actions class="justify-content-end w-100 mt-2 mb-0 pb-0">
    <button
      mat-stroked-button
      id="yes-btn"
      class="everbtn-slight-wide"
      (click)="clickYes()"
      type="button"
    >
      {{ textForYes }}
    </button>
    <button
      mat-stroked-button
      *ngIf="buttons !== 1 && buttons !== 6"
      id="no-btn"
      class="plain-button everbtn-slight-wide"
      (click)="clickNo()"
      type="button"
    >
      {{ textForNo }}
    </button>
  </div>
</div>
